/**
 * @generated SignedSource<<e2c6e38f14cad25fe4b10adb65305f15>>
 * @relayHash 67adbb4247caf79c789265b58619d9ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c071cdd154593b5019dc5c142be78f068f91f1bcef56b4b89da0c4203c020dbb

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConvoAiHomeThreadsInput = {
  promptOverride?: string | null | undefined;
  userId: string;
};
export type ThreadsV2_Query$variables = {
  cloudId: string;
  experience: string;
  homeThreadsInput: ConvoAiHomeThreadsInput;
  isEnabled: boolean;
};
export type ThreadsV2_Query$data = {
  readonly convoai_homeThreads?: {
    readonly " $fragmentSpreads": FragmentRefs<"RecommendedFeedInternal_AtlassianRecommendedFeed">;
  } | null | undefined;
};
export type ThreadsV2_Query = {
  response: ThreadsV2_Query$data;
  variables: ThreadsV2_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "homeThreadsInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "homeThreadsInput",
    "variableName": "homeThreadsInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "url"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v7 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v8 = [
  (v3/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = [
  (v4/*: any*/),
  (v9/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v2/*: any*/)
],
v11 = [
  {
    "concreteType": "ConfluenceBodies",
    "kind": "LinkedField",
    "name": "body",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "length",
            "value": 250
          }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:250)"
      }
    ]
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v3/*: any*/),
          (v7/*: any*/)
        ],
        "type": "ConfluencePage"
      },
      {
        "kind": "InlineFragment",
        "selections": (v8/*: any*/),
        "type": "ConfluenceBlogPost"
      },
      {
        "kind": "InlineFragment",
        "selections": (v8/*: any*/),
        "type": "ConfluenceWhiteboard"
      },
      (v6/*: any*/)
    ]
  },
  (v9/*: any*/),
  {
    "concreteType": "ConfluenceUserInfo",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": (v10/*: any*/)
      },
      (v2/*: any*/)
    ]
  },
  {
    "concreteType": "ConfluenceContentVersion",
    "kind": "LinkedField",
    "name": "latestVersion",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "createdAt"
      },
      {
        "kind": "ScalarField",
        "name": "number"
      }
    ]
  }
],
v12 = [
  {
    "kind": "ScalarField",
    "name": "plainText"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "summary"
},
v14 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorName"
        },
        (v2/*: any*/)
      ]
    },
    (v2/*: any*/)
  ]
},
v15 = [
  {
    "concreteType": "JiraRichText",
    "kind": "LinkedField",
    "name": "richText",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraADF",
        "kind": "LinkedField",
        "name": "adfValue",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraAdfToConvertedPlainText",
            "kind": "LinkedField",
            "name": "convertedPlainText",
            "plural": false,
            "selections": (v12/*: any*/)
          }
        ]
      }
    ]
  },
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v13/*: any*/),
      (v2/*: any*/),
      (v14/*: any*/)
    ]
  },
  {
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": (v10/*: any*/)
  },
  {
    "kind": "ScalarField",
    "name": "updated"
  },
  {
    "kind": "ScalarField",
    "name": "created"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v17 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v16/*: any*/),
        (v9/*: any*/),
        (v2/*: any*/)
      ]
    },
    (v2/*: any*/)
  ]
},
v18 = {
  "concreteType": "ConfluenceBodies",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "length",
          "value": 300
        }
      ],
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": "excerpt(length:300)"
    }
  ]
},
v19 = [
  (v4/*: any*/),
  (v16/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "RecommendedFeedInternal_AtlassianRecommendedFeed"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThreadsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ConvoAiHomeThread",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isConvoAiHomeThreadSource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "ari"
                              },
                              (v5/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v6/*: any*/)
                                ]
                              }
                            ],
                            "type": "ConvoAiHomeThreadsFirstPartySource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "type": "ConvoAiHomeThreadsThirdPartySource"
                          }
                        ]
                      },
                      {
                        "concreteType": "ConvoAiHomeThreadSuggestedAction",
                        "kind": "LinkedField",
                        "name": "suggestedActions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "action"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "source",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v11/*: any*/),
                                        "type": "ConfluenceFooterComment"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v11/*: any*/),
                                        "type": "ConfluenceInlineComment"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v15/*: any*/),
                                        "type": "JiraPlatformComment"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v15/*: any*/),
                                        "type": "JiraServiceManagementComment"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v3/*: any*/),
                                          (v2/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "type": "ConfluencePage"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v3/*: any*/),
                                          (v2/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/)
                                        ],
                                        "type": "ConfluenceBlogPost"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          {
                                            "concreteType": "JiraRichTextField",
                                            "kind": "LinkedField",
                                            "name": "descriptionField",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraRichText",
                                                "kind": "LinkedField",
                                                "name": "richText",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "adfValue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "firstNCharacters",
                                                            "value": 300
                                                          }
                                                        ],
                                                        "concreteType": "JiraAdfToConvertedPlainText",
                                                        "kind": "LinkedField",
                                                        "name": "convertedPlainText",
                                                        "plural": false,
                                                        "selections": (v12/*: any*/),
                                                        "storageKey": "convertedPlainText(firstNCharacters:300)"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v2/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "name": "reporter",
                                            "plural": false,
                                            "selections": (v19/*: any*/)
                                          },
                                          {
                                            "concreteType": "JiraDatePickerField",
                                            "kind": "LinkedField",
                                            "name": "dueDateField",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "date"
                                              },
                                              (v2/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraSingleSelectUserPickerField",
                                            "kind": "LinkedField",
                                            "name": "assigneeField",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": (v19/*: any*/)
                                              },
                                              (v2/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssue"
                                      },
                                      (v6/*: any*/)
                                    ]
                                  },
                                  (v5/*: any*/)
                                ],
                                "type": "ConvoAiHomeThreadsFirstPartySource"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c071cdd154593b5019dc5c142be78f068f91f1bcef56b4b89da0c4203c020dbb",
    "metadata": {},
    "name": "ThreadsV2_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "731c7dc7747c5940a3d1977fd63911b2";

export default node;
